import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import back from "../assets/images/back_arrow.png";
import Axios from "axios";
import { useLocation } from "react-router";
import $ from "jquery";
import { message } from "antd";
import "../css/Header.css";
const moment = require("moment");
const ViewTicket = () => {
  const [ticketDetails, setTicketDetails] = useState([]);
  const [isOpenInput, setIsOpenInput] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [feedbackMsg, setFeedbackMsg] = useState("");
  const [buttonHide, setButtonHide] = useState(false);
  // const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const backHandler = () => {
    global.OTPValidation = "true";
    navigate("/Tickets");
  };
  const location = useLocation();
  console.log("state: ", location.state);
  let ticket_number = location.state.ticket_number;
  useEffect(() => {
    const fetchTickets = async () => {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientsSupport/get_ticket_by_ticketno?ticket_number=${ticket_number}&MDT=PM&user_role=rp`,
          { headers }
        );

        if (response.data.status == "1") {
          setTicketDetails(response.data.data);
        } else if (response.data.status == "401") {
          message.error("Unauthorized access. Logging out.");
          logoutHandler();
        }else{
          console.error("An error occurred while fetching tickets. Please try again later.");
        }
      } catch (error) {
        if (error.response && error.response.status == '401') {
          console.error("Unauthorized access. Logging out.");
          logoutHandler();
        } else {
          console.error("Error:", error.message);
        }
      }
    };
    fetchTickets();
  }, []);
  let feddback = [
    {
      id: 1,
      key: "1",
      value: "Problem Solved",
    },
    {
      id: 2,
      key: "0",
      value: "Need more advice",
    },
  ];
  const onFeddbackChange = (e, key) => {
    console.log(e.target.value);
    setFeedback(key);
    if (key == "0") {
      setIsOpenInput(true);
    }
  };
  const onFeedbackMsg = (e) => {
    setFeedbackMsg(e.target.value);
  };
  const postHandler = (e) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    setButtonHide(true);
    e.preventDefault();
    console.log("fgg");
    // setErrMsg("");

    let formdata = $(e.target);
    formdata = new FormData();
    formdata.append("ticket_number", ticket_number);
    formdata.append("feedback", feedback);
    formdata.append("feedbackMessage", feedbackMsg);
    formdata.append('MDT', 'PM');
    formdata.append('user_role', 'rp');

    $.ajax({
      type: "POST",
      url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientsSupport/update_feedback`,
      data: formdata,
      processData: false,
      contentType: false,
      headers: headers,
      success(data) {
        console.log("post successfully", data);
        setTimeout(navigate("/Tickets"), 2000);
      },
      error(err) {
        if (err.status === 401) {
          // Token expired, show message and log out
          message.error(err.responseJSON.message);
          logoutHandler();
        } else {
          console.error("Error occurred:", err.responseText);
          alert("Error has occurred: ", err.responseText);
        }
      },
    });
  };

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");
  };

  return (
    <div className="support-issues-container">
      <header className="header">
        <img
          src={back}
          style={{ height: 20, width: 20 }}
          alt="back button"
          onClick={backHandler}
        />
        <h1 className="header-title">Support Issues</h1>
      </header>

      <div className="ticket-details-container">
        {ticketDetails.map((details, index) => (
          <div className="ticket-card" key={index}>
            <div className="ticket-row">
              <p className="value"><strong className="label">Ticket No:</strong> {details.ticket_number}</p>
            </div>
            <div className="ticket-row">
              <p className="value">
               <strong className="label">Date:</strong> {moment(details.create_datetime).format("DD.MM.YYYY")}
              </p>
            </div>
            <div className="ticket-row">
              <p className="value">
              <strong className="label">Status:</strong> {details.status === "0" && "Submitted"}
                {details.status === "1" && "Processing"}
                {details.status === "2" && "Replied"}
                {details.status === "3" && "Solved"}
                {details.status === "4" && "Rejected"}
              </p>
            </div>
            <div className="ticket-row" style={{ flexDirection: "column", alignItems: 'start' }}>
              <p className="value"><strong className="label">Problem Statement:</strong> {details.problem_details}</p>
            </div>
            {details.problem_response && (
              <div className="ticket-row">
                <p className="value"><strong className="label">Reply:</strong> {details.problem_response}</p>
              </div>
            )}
            {details.status === "2" && (
              <div className="feedback-section">
                <p className="label">Feedback:</p>
                {feddback.map((val) => (
                  <div className="feedback-option" key={val.key}>
                    <input
                      type="radio"
                      className="feedback-input"
                      value={val.value}
                      name="feedback"
                      onChange={(event) => onFeddbackChange(event, val.key)}
                    />
                    <p className="feedback-label">{val.value}</p>
                  </div>
                ))}
                {isOpenInput && (
                  <textarea
                    className="feedback-textarea"
                    id="feedbackMsg"
                    name="feedbackMsg"
                    rows="5"
                    value={feedbackMsg}
                    onChange={(event) => onFeedbackMsg(event)}
                    placeholder="Add message here"
                  ></textarea>
                )}
                <form method="post" onSubmit={(event) => postHandler(event)}>
                  {buttonHide === false ? (
                    <button type="submit" className="submit-feedback-btn">
                      Post
                    </button>
                  ) : (
                    <p className="sending-feedback">Sending...</p>
                  )}
                </form>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>

  );
};

export default ViewTicket;
